import { getApiOrigin } from '../config/api';

const BACKEND_HOSTS = new Set(['127.0.0.1', 'localhost', 'manage.swarvinnfoods.co.uk']);
const MEDIA_EXTENSION_PATTERN = /\.(jpe?g|png|gif|webp|svg)$/i;

function stripMediaExtension(path) {
  return path.replace(MEDIA_EXTENSION_PATTERN, '');
}

function toApiMediaPath(path) {
  let normalized = path;

  if (normalized.startsWith('/media/')) {
    normalized = normalized.replace('/media/', '/api/media/');
  } else if (normalized.startsWith('/storage/')) {
    normalized = `/api/media/${normalized.slice('/storage/'.length)}`;
  }

  if (!normalized.startsWith('/api/media/')) {
    return normalized;
  }

  return stripMediaExtension(normalized);
}

function withApiOrigin(path) {
  if (process.env.NODE_ENV === 'development') {
    return path;
  }

  return `${getApiOrigin()}${path}`;
}

/**
 * Rewrites backend media URLs for the current environment.
 * Dev: same-origin /api/media paths via the React proxy.
 * Production: absolute URLs on the Laravel backend host.
 */
export function resolveMediaUrl(url) {
  if (!url || typeof url !== 'string') {
    return url;
  }

  if (url.startsWith('data:')) {
    return url;
  }

  const cacheBust = 'v=20260812';

  if (url.startsWith('/') && !url.startsWith('//')) {
    if (url.startsWith('/api/media/') || url.startsWith('/media/') || url.startsWith('/storage/')) {
      const resolved = withApiOrigin(toApiMediaPath(url));
      return resolved.includes('?') ? `${resolved}&${cacheBust}` : `${resolved}?${cacheBust}`;
    }

    return url;
  }

  try {
    const parsed = new URL(url);

    if (!BACKEND_HOSTS.has(parsed.hostname)) {
      return url;
    }

    const apiPath = toApiMediaPath(parsed.pathname);

    if (apiPath.startsWith('/api/media/')) {
      const resolved = withApiOrigin(apiPath);
      return resolved.includes('?') ? `${resolved}&${cacheBust}` : `${resolved}?${cacheBust}`;
    }
  } catch {
    // Not a valid absolute URL — return as-is.
  }

  return url;
}
